import React 					from 'react';
import PropTypes 				from 'prop-types';
import BLComponent 				from '../core/_BLComponent.jsx';

import BreadCrumbs 				from '../common/_BreadCrumbs.jsx';
import CustomCheckbox 			from '../common/_CustomCheckbox.jsx';
import ControlledNumberInput 	from '../common/_ControlledNumberInput.jsx';

//this.props.classes			: string of classes
/*this.props.data					: {
																link 			: (optional) string of link
															, image 			: string of image url
															, name 				: string of name
															, itemNumber 		: (optional) string of item number
															, altItemNumber 	: (optional) string of alt item number
															, condition 		: (optional) char for condition mapping 
															, sub condition 	: (optional) char for sub-condition mapping 
															, inventory 		: (optional) url of inventory listing
															, year 				: (optional) integer of year
															, qtyInSet 			: (optional) integer of qty
															, altMatchID 		: (optional) integer of matching ids
															, price 			: (optional) string of price
															, qty 				: (optional) integer of qty
														}*/
/*this.props.edit					: (optional) {
																enabled 			: boolean
															,	isChecked 		: boolean
															, onChangefunc 	: function that should take place when clicked
														}*/

/*this.props.editQty				: (optional) {
																enabled 			: boolean
															,	limit 				: integer for qty limit
															,	qty 					: integer for qty
															, onChangefunc 	: function that should take place when clicked
														}*/

/*this.props.wantedList			: (optional) {
																enabled 			: boolean
															,	isWanted 			: boolean
															, wantedCount 	: integer of how many times appears on wanted lists
														}*/

//this.props.size					: (optional) large || 
//this.props.status				: (optional) integer of status from 0 to 5 
//this.props.remainingQty	: (optional) integer of qty remaining, not optional if pillType is 0

/*this.props.counters			: (optional) {
															colors		: (optional) integer of color count
														,	sets 			: (optional) integer of set count
														,	parts 		: (optional) integer of part count
														,	minifigs	: (optional) integer of minifig count
													}*/

//this.props.breadcrumbs 	: (optional) array of {link: string, content: string}

export default class ProductListingItem extends BLComponent 
{
	constructor(props) 
	{
		super(props);

		this.state = {
			wantedListEnabled:	( props.wantedList && props.wantedList.enabled )
		,	isWanted:			( props.wantedList && props.wantedList.isWanted )
		,	wantedCnt:			( props.wantedList && props.wantedList.wantedCount ) ? props.wantedList.wantedCount : 0
		, limitedAvailable: true
		}

		this.condition = {
			'X': '(Unrated)'
		,	'N': 'New'
		,	'U': 'Used'
		};

		this.subCondition = {
			'C': 'Complete'
		,	'B': 'Incomplete'
		,	'S': 'Sealed'
		};
	}

	static getDerivedStateFromProps( nextProps, prevState ) 
	{
		prevState.wantedListEnabled	= ( nextProps.wantedList && nextProps.wantedList.enabled );
		prevState.limitedAvailable	= nextProps.limitedAvailable == true ? true : false;

		return prevState;
	}	

	componentDidMount() 
	{
		if ( this.state.wantedListEnabled && this.props.wantedList.dmItemView )
		{
			blapp.personalized.fetchWantedPrefData( this.props.wantedList.dmItemView.dmItem.idItem, this.props.wantedList.idColor > 0 ? this.props.wantedList.idColor : 0, this.updateWantedPrefInfo );
		}
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		if ( this.state.wantedListEnabled )
			blapp.personalized.unregisterCallback( this.updateWantedPrefInfo );
	}

	componentDidUpdate( prevProps, prevState, snapshot ) 
	{ 
		super.componentDidUpdate( prevProps, prevState, snapshot ); 

		if ( this.props.wantedList && this.props.wantedList.enabled && this.props.wantedList.dmItemView )
		{
			if ( prevProps.wantedList && prevProps.wantedList.enabled && prevProps.wantedList.dmItemView == this.props.wantedList.dmItemView && prevProps.wantedList.idColor == this.props.wantedList.idColor )
			{
				// Do Nothing!
			}
			else
			{	// Update Wanted Pref Data
				blapp.personalized.fetchWantedPrefData( this.props.wantedList.dmItemView.dmItem.idItem, this.props.wantedList.idColor > 0 ? this.props.wantedList.idColor : 0, this.updateWantedPrefInfo );
			}
		}
	}		

	render() {
		const {classes = '', size, status = null, remainingQty = null, counters = null, isCatalog = false, newWindowLink = false, show, showUnavailable = false} = this.props;
		const {link = null, image, name, itemNumber = null, altItemNumber = null, inventory = false, condition = null, subCondition = null, year = null, qtyInSet = null, altMatchID = null, price = null, qty = null, bulk = 0, totalPrice = null, idCurrency = null, itemType} = this.props.data;
		let {breadcrumbs = null} = this.props;

		const editEnabled 			= this.props.edit ? (this.props.edit.enabled || false) : false;
		const editIsChecked 		= this.props.edit ? (this.props.edit.isChecked || false) : false;

		const editQtyEnabled 		= this.props.editQty ? (this.props.editQty.enabled || false) : false;
		const editQtyOnChangeFunc 	= this.props.editQty ? (this.props.editQty.onChangeFunc || null) : false;
		const editQtyLimit 			= this.props.editQty ? (this.props.editQty.limit || null) : false;
		const editQtyQty			= this.props.editQty ? (this.props.editQty.qty || null) : false;

		const wantedListEnabled 	= this.state.wantedListEnabled;
		const wantedListIsWanted 	= this.state.isWanted;
		const wantedListCount 		= this.state.wantedCnt;
		const wantedListFixedIcon 	= this.props.wantedList ? this.props.wantedList.fixedIcon : false;

		const altType = itemType != 'S' && itemType != 'P' && itemType != 'M';

		if (isCatalog && itemNumber) 
			breadcrumbs = [...breadcrumbs, {link: '', content: itemNumber}];

		return (
			<article className={"product-listing-item " + classes}>
				<div className="product-listing-item__internal">
					{editEnabled ?
						<CustomCheckbox classes="product-listing-item__checkbox" isChecked={editIsChecked} onChangeFunc={this.toggleCheckBox}/>
					: null}
					{wantedListEnabled && wantedListFixedIcon ? 
						<button className="btn btn--blank product-listing-item__fixed-wantedlist-icon" onClick={() => this.toggleAddWantedList()}>{wantedListIsWanted ? <i className="fas fa-heart product-card__wanted-icon--active"/> : <i className="far fa-heart"/>}</button> 
					: null}
					<div className={"product-listing-item__image" + (size ? ` product-listing-item__image--${size}` : '')}>
						{link && !editEnabled ?
							<a className="link--inherit" href={link} target={newWindowLink ? "_blank" : ""}>
								<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
							</a>
						:
							<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
						}
					</div>
					<div className="product-listing-item__info">
						{breadcrumbs ? 
							<BreadCrumbs classes="product-listing-item__categories" crumbs={breadcrumbs} clean={true} type={'arrow'}/> 
						: null}
						{condition ? <div className="product-listing-item__condition">{this.getConditionString(condition, subCondition)}</div> : null}
						{link ? 
							<a className="link--inherit product-listing-item__name text--bold" href={link} target={newWindowLink ? "_blank" : ""}>{name}</a>
						:
							<strong className="product-listing-item__name">{name}</strong>
						}
						{itemNumber && !isCatalog ? <div className="product-listing-item__number">{itemNumber ? `Item No: ${itemNumber}` : null} {inventory ? <a className="btn--link" href={inventory}>(Inv)</a> : null} {altItemNumber ? `Alt No: ${altItemNumber}` : null}</div> : null}
						{year ? <div className="product-listing-item__meta-info">{year}</div> : null}
						{qtyInSet ? <div className="product-listing-item__meta-info">{$T("QTY_IN_SET")} {qtyInSet}</div> : null}
						{altMatchID ? <div className="product-listing-item__meta-info">{$T("ALT_MATCH_ID")} {altMatchID}</div> : null}
						
						{price || qty ? <div className="product-listing-item__meta-info">{qty ? <span className="product-listing-item__qty">{$T("QTY")} {qty} {bulk > 1 && `(x${bulk})`}</span> : null} {price ? <span className="product-listing-item__price">{blapp.format.formatMoney(price, idCurrency)}</span> : null}</div> : null}
						{this.state.limitedAvailable ? <span className="text-color--primaryRed product-listing-item__limited-available">{$T( "ALMOST_GONE" )}</span> : ( totalPrice || price ? <strong className="text-color--primaryGreen">{blapp.format.formatMoney(totalPrice || price, idCurrency)}</strong> : null)}
						{editQtyEnabled ? 
							<ControlledNumberInput classes={'l-margin-top'} limit={editQtyLimit} value={editQtyQty} onChangeFunc={(e) => editQtyOnChangeFunc(e)}/>
						: null}
						{counters ? this.renderCounters() : null}
						{wantedListEnabled && !wantedListFixedIcon ?
							<div className="product-listing-item__wanted product-card__wanted-list">
								<button className="l-cursor-pointer" onClick={() => this.toggleAddWantedList()}>
									<i className={"product-card__wanted-icon l-margin-right--sm " + (wantedListIsWanted ? "fas fa-heart" : "far fa-heart") + (wantedListIsWanted ? " product-card__wanted-icon--active" : "")}></i>
									{wantedListCount}
								</button>
							</div>
						: null}
						{this.props.children ? this.props.children : null}
					</div>
				</div>
			</article>
		);
	}

	getConditionString(condition, subCondition) 
	{
		let str = null;
		if (this.condition[condition])
			str = this.condition[condition];
		if (this.subCondition[subCondition])
			str += ' ' + this.subCondition[subCondition];
		return str;
	}

	toggleCheckBox = () => {
		if(this.props.edit && this.props.edit.onChangeFunc)
			this.props.edit.onChangeFunc(this.props.edit.idToggle)
	}

	renderCounters() 
	{
		const {colors = null, sets = null, parts = null, minifigs = null} = this.props.counters;

		return (
			<div className="product-listing-item__counters">
				{colors ? <div className="product-listing-item__meta-info"><i className="fas fa-cube l-margin-right--sm"/>{colors} color{colors > 1 ? 's' : null}</div> : null}
				{sets ? <div className="product-listing-item__meta-info"><i className="fas fa-cube l-margin-right--sm"/>{sets} set{sets > 1 ? 's' : null}</div> : null}
				{parts ? <div className="product-listing-item__meta-info"><i className="fas fa-cube l-margin-right--sm"/>{parts} part{parts > 1 ? 's' : null}</div> : null}
				{minifigs ? <div className="product-listing-item__meta-info"><i className="fas fa-cube l-margin-right--sm"/>{minifigs} minifig{minifigs > 1 ? 's' : null}</div> : null}
			</div>
		);
	}

	toggleAddWantedList = () => 
	{
		if ( this.state.wantedListEnabled )
		{
			const	srcMap 	= 	_.assign( 
									{ location: blapp.srcmap.LOCATION.GENERAL_XP, typeSrcFrom: blapp.srcmap.SRCTYPE.CATALOG_ITEM, idSrcFrom: this.props.wantedList.dmItemView.dmItem.idItem }
								,	this.props.wantedList && this.props.wantedList.srcMap ? this.props.wantedList.srcMap : {}
								);

			blapp.wanted.showAddWantedListModal
			(
				this.props.wantedList.dmItemView
			,	() => { blapp.personalized.fetchWantedPrefData( this.props.wantedList.dmItemView.dmItem.idItem, this.props.wantedList.idColor > 0 ? this.props.wantedList.idColor : 0, this.updateWantedPrefInfo ); }
			,	srcMap
			);
		}


		//this.setState({showWantedModal: !this.state.showWantedModal});
	}

	updateWantedPrefInfo = ( data ) => 
	{
		if ( data && data.dataWantedPref )
		{
			this.setState( { isWanted: data.dataWantedPref.bIsWanted, wantedCnt: data.dataWantedPref.nWantedUserCnt } );
		}
	}	

	static getDataFromItemWithColor( dmItemWithColor )
	{
		return ProductListingItem.getDataFromItemAndImg( dmItemWithColor.dmItem, dmItemWithColor.dmImg, dmItemWithColor.idColor )
	}

	static getDataFromWantedItem( dmWantedItem )
	{
		const dmItem	= dmWantedItem.dmItemImage.dmItem;
		const dmImg		= dmWantedItem.dmItemImage.dmImg;
		return ProductListingItem.getDataFromItemAndImg( dmItem, dmWantedItem.nWantedColorId > 0 ? dmImg : dmItem.imgDefault, dmWantedItem.nWantedColorId  );
	}

	static getDataFromItemAndImg( dmItem, dmImg, idColor )
	{
		return	{
					link:		blapp.url2.getCatalogItemPageUrl( dmItem, idColor )
				,	image: 		blapp.url2.getCatalogItemImgUrl( dmImg,"T2" )
				,	name:		dmItem.strItemName
				,	itemNumber:	dmItem.strItemNoFull
				//,	inventory:	dmItem.typeItem == 'S' ? '#' : null
				,	inventory:	null
				,	type:		dmItem.typeItem
				}
	}

	static getDataFromItemInv( dmItemInv, showColorName )
	{
		const 	dmBasic = dmItemInv.dmItem.dmItem;
		let		colorText	= "";

		if ( showColorName && dmBasic.bColorEnabled )
		{
			let	ci	= blapp.color.get( dmItemInv.dmItem.idColor );

			if ( ci )
				colorText	= "[" + ci.strColorName + "] ";
		}

		return	{
					link:		blapp.url2.getCatalogItemPageUrl( dmBasic, dmItemInv.dmItem.idColor )
				,	image: 		blapp.url2.getCatalogItemImgUrl( dmItemInv.dmItem.dmImg, "T2" )
				,	name:		colorText + dmBasic.strItemName
				,	itemNumber:	dmBasic.strItemNoFull
				,	qty: 		dmItemInv.nQty
				}
	}


	static getDataFromOrderItem( dmOrderItem, idCurrency )
	{
		const data =	{
							condition:		dmOrderItem.codeCondition
						,	subCondition:	dmOrderItem.codeComplete
						,	qty:			dmOrderItem.nQty * dmOrderItem.nBindQty
						,	price:			dmOrderItem.mUnitPrice
						,	totalPrice:		dmOrderItem.mFinalPrice
						,	bulk:			dmOrderItem.nBulk
						,	idCurrency:		idCurrency
						};

		if ( dmOrderItem.statusItem == "U" )
		{
			data.image 		= dmOrderItem.strOrderItemImgUrl;
			data.name 		= dmOrderItem.strDesc;
			data.itemNumber	= "Custom";
		}
		else
		{
			const dmItem = dmOrderItem.dmItemWithImg.dmItem;
			const dmImg	 = dmOrderItem.dmItemWithImg.dmImg;
			let	colorText	= "";

			if ( dmItem.bColorEnabled )
			{
				let	ci	= blapp.color.get( dmOrderItem.idColor );
	
				if ( ci )
					colorText	= "[" + ci.strColorName + "] ";
			}

			data.image 		= dmOrderItem.strOrderItemImgUrl ? dmOrderItem.strOrderItemImgUrl : blapp.url2.getCatalogItemImgUrl(dmImg,"T2");
			data.name 		= colorText + dmItem.strItemName;
			data.itemNumber	= dmItem.strItemNoFull;

			data.link		= blapp.url2.getCatalogItemPageUrl( dmItem, dmOrderItem.idColor );
		}

		return data;
	}

	static getWantedListEnableInfoFromItemInv( dmItemInv, srcMap )
	{
		return 	{
					enabled: 		true
				,	isWanted:		false
				,	fixedIcon:		true
				,	wantedCount: 	0
				,	dmItemView:		dmItemInv.dmItem
				,	srcMap:			srcMap
				};
	}

	static getWantedListEnableInfo( dmItemView, srcMap )
	{
		return 	{
					enabled: 		true
				,	isWanted:		false
				,	wantedCount: 	0
				,	fixedIcon:		false
				,	dmItemView:		dmItemView
				,	srcMap:			srcMap
				};
	}	
}

ProductListingItem.propTypes = 
{
	classes:			PropTypes.string
,	showUnavailable: PropTypes.bool
,	data:				PropTypes.shape(
							{
								link:			PropTypes.string
							,	image:			PropTypes.string.isRequired
							,	name:			PropTypes.string.isRequired
							,	itemNumber:		PropTypes.string
							,	altItemNumber:	PropTypes.string
							,	condition:		PropTypes.oneOf(['U', 'N', 'X'])
							,	subCondition:	PropTypes.oneOf(['C', 'B', 'S', 'X'])
							,	inventory:		PropTypes.string
							,	year:			PropTypes.number
							,	qtyInSet:		PropTypes.number
							,	altMatchID:		PropTypes.number
							,	price:			PropTypes.number
							,	totalPrice:		PropTypes.number
							,	qty:			PropTypes.number
							,	bulk:			PropTypes.number
							,	idCurrency:		PropTypes.number
						}).isRequired
	,	edit:			PropTypes.shape(
							{
								enabled:		PropTypes.bool.isRequired
							,	isChecked:		PropTypes.bool.isRequired
							,	onChangeFunc:	PropTypes.func.isRequired
							}
						)
	,	editQty:		PropTypes.shape(
							{
								enabled:		PropTypes.bool.isRequired
							,	limit:			PropTypes.number.isRequired
							,	qty:			PropTypes.number.isRequired
							,	onChangeFunc:	PropTypes.func.isRequired
							}
						)
	,	wantedList:		PropTypes.shape(	
							{
								enabled:		PropTypes.bool
							,	isWanted:		PropTypes.bool
							,	wantedCount:	PropTypes.number
							,	fixedIcon: 		PropTypes.bool
							,	dmItemView:		PropTypes.object
							,	srcMap:			PropTypes.object							
							}
						)
	,	size:			PropTypes.oneOf(['large'])
	,	status:			PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	,	remainingQty: 	function(props, propName, componentName) 
						{
							if(props['status'] === 0 && props[propName] == undefined) return new Error('You must provide a remainingQty when having a status of 0')
						}
	,	counters:		PropTypes.shape(
							{
								colors:		PropTypes.number
							,	sets:		PropTypes.number
							,	parts:		PropTypes.number
							,	minifigs:	PropTypes.number
							}
						)
	,	breadcrumbs:	PropTypes.arrayOf(
							PropTypes.shape(
								{
									link:		PropTypes.string.isRequired
								,	content:	PropTypes.string.isRequired
								}
							)
						)
}

var $T = BLComponent.createTextMap(
	{
		"QTY_IN_SET":
		{
			"en":	"Qty in set:"
		,	"kr":	"세트 내 수량:"
		,	"es":	"Cantidad en el set:"
		}
	,	"ALT_MATCH_ID":
		{
			"en":	"Alt match ID:"
		,	"kr":	"대체 식별 번호:"
		,	"es":	"ID alternativo"
		}
	,	"QTY":
		{
			"en":	"Qty:"
		,	"kr":	"수량:"
		,	"es":	"Cantidad:"
		}
	,	"ALMOST_GONE":
		{
			"en":	"Almost gone"
		,	"kr":	"품절 임박"
		,	"es":	"Últimas unidades"
		}
	}
);